import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const bookingId = searchParams.get("booking_id");

  return (
    <div className="payment-result-page" data-testid="payment-cancel-page">
      <div className="result-container">
        <Card className="result-card">
          <CardHeader>
            <CardTitle className="text-center">
              <XCircle size={64} className="mx-auto mb-4 text-orange-600" />
              <h2>Payment Cancelled</h2>
            </CardTitle>
          </CardHeader>
          <CardContent className="result-content">
            <p>Your payment was cancelled. You can try booking again whenever you're ready.</p>
            <div className="button-group">
              <Button onClick={() => navigate("/user-dashboard")} data-testid="dashboard-button">
                Go to Dashboard
              </Button>
              <Button variant="outline" onClick={() => navigate("/book-ride")} data-testid="book-again-button">
                Book Again
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
